import { render, staticRenderFns } from "./view_ProductPage.vue?vue&type=template&id=e2788f7a&scoped=true&"
import script from "./view_ProductPage.vue?vue&type=script&lang=js&"
export * from "./view_ProductPage.vue?vue&type=script&lang=js&"
import style0 from "./view_ProductPage.vue?vue&type=style&index=0&id=e2788f7a&prod&lang=css&"
import style1 from "./view_ProductPage.vue?vue&type=style&index=1&id=e2788f7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2788f7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
